define.alias("shared/components/shared/stop-the-world-modal", "calendar/components/shared/stop-the-world-modal");